import { render, staticRenderFns } from "./CompanysHistoryTable.vue?vue&type=template&id=3bb94cae"
import script from "./CompanysHistoryTable.vue?vue&type=script&lang=js"
export * from "./CompanysHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports